// Load WMR Config
export const WMR_CONFIG_LOAD = 'WMR_CONFIG_LOAD'
export const wmrConfigLoad = (
  accountId: string,
  projectId: string
): WmrConfigLoadAction => ({
  type: WMR_CONFIG_LOAD,
  accountId,
  projectId
})

export const WMR_CONFIG_LOAD_SUCCESS = 'WMR_CONFIG_LOAD_SUCCESS'
export const wmrConfigLoadSuccess = (
  accountId: string,
  projectId: string,
  config: WmrConfigData
): WmrConfigLoadSuccessAction => ({
  type: WMR_CONFIG_LOAD_SUCCESS,
  accountId,
  projectId,
  config
})

export const WMR_CONFIG_LOAD_FAIL = 'WMR_CONFIG_LOAD_FAIL'
export const wmrConfigLoadFailure = (
  accountId: string,
  projectId: string,
  error: any
): WmrConfigLoadFailAction => ({
  type: WMR_CONFIG_LOAD_FAIL,
  accountId,
  projectId,
  error
})

// Upload Ruleset
export const WMR_RULESET_UPLOAD = 'WMR_RULESET_UPLOAD'
export const wmrRulesetUpload = (
  accountId: string,
  projectId: string,
  file: File
): WmrRulesetUploadAction => ({
  type: WMR_RULESET_UPLOAD,
  accountId,
  projectId,
  file
})

export const WMR_RULESET_UPLOAD_SUCCESS = 'WMR_RULESET_UPLOAD_SUCCESS'
export const wmrRulesetUploadSuccess = (
  accountId: string,
  projectId: string,
  response: WmrUploadResponse
): WmrRulesetUploadSuccessAction => ({
  type: WMR_RULESET_UPLOAD_SUCCESS,
  accountId,
  projectId,
  response
})

export const WMR_RULESET_UPLOAD_FAIL = 'WMR_RULESET_UPLOAD_FAIL'
export const wmrRulesetUploadFailure = (
  accountId: string,
  projectId: string,
  error: any
): WmrRulesetUploadFailAction => ({
  type: WMR_RULESET_UPLOAD_FAIL,
  accountId,
  projectId,
  error
})

// Confirm Ruleset
export const WMR_RULESET_CONFIRM = 'WMR_RULESET_CONFIRM'
export const wmrRulesetConfirm = (
  accountId: string,
  projectId: string,
  rulesetId: string
): WmrRulesetConfirmAction => ({
  type: WMR_RULESET_CONFIRM,
  accountId,
  projectId,
  rulesetId
})

export const WMR_RULESET_CONFIRM_SUCCESS = 'WMR_RULESET_CONFIRM_SUCCESS'
export const wmrRulesetConfirmSuccess = (
  accountId: string,
  projectId: string,
  rulesetId: string
): WmrRulesetConfirmSuccessAction => ({
  type: WMR_RULESET_CONFIRM_SUCCESS,
  accountId,
  projectId,
  rulesetId
})

export const WMR_RULESET_CONFIRM_FAIL = 'WMR_RULESET_CONFIRM_FAIL'
export const wmrRulesetConfirmFailure = (
  accountId: string,
  projectId: string,
  rulesetId: string,
  error: any
): WmrRulesetConfirmFailAction => ({
  type: WMR_RULESET_CONFIRM_FAIL,
  accountId,
  projectId,
  rulesetId,
  error
})

// Export Current Ruleset
export const WMR_RULESET_EXPORT = 'WMR_RULESET_EXPORT'
export const wmrRulesetExport = (
  accountId: string,
  projectId: string
): WmrRulesetExportAction => ({
  type: WMR_RULESET_EXPORT,
  accountId,
  projectId
})

export const WMR_RULESET_EXPORT_SUCCESS = 'WMR_RULESET_EXPORT_SUCCESS'
export const wmrRulesetExportSuccess = (
  accountId: string,
  projectId: string,
  exportFileSasUrl: string
): WmrRulesetExportSuccessAction => ({
  type: WMR_RULESET_EXPORT_SUCCESS,
  accountId,
  projectId,
  exportFileSasUrl
})

export const WMR_RULESET_EXPORT_FAIL = 'WMR_RULESET_EXPORT_FAIL'
export const wmrRulesetExportFailure = (
  accountId: string,
  projectId: string,
  error: any
): WmrRulesetExportFailAction => ({
  type: WMR_RULESET_EXPORT_FAIL,
  accountId,
  projectId,
  error
})

// Reset Upload State
export const WMR_RULESET_UPLOAD_RESET = 'WMR_RULESET_UPLOAD_RESET'
export const wmrRulesetUploadReset = (): WmrRulesetUploadResetAction => ({
  type: WMR_RULESET_UPLOAD_RESET
})

// Reset Export State
export const WMR_RULESET_EXPORT_RESET = 'WMR_RULESET_EXPORT_RESET'
export const wmrRulesetExportReset = (): WmrRulesetExportResetAction => ({
  type: WMR_RULESET_EXPORT_RESET
})

// INTERFACES
export interface WmrConfigData {
  templateSasUrl: string | null
  activeRuleset?: {
    ruleCount: number
    isReprocessing: boolean
  }
}

export interface ValidationIssue {
  column: string
  message: string
  isError: boolean
}

export interface ValidationResult {
  rowNumber: number
  issues: ValidationIssue[]
}

export interface WmrUploadResponse {
  rulesetId: string | null
  ruleCount: number
  isValid: boolean
  validationResults: ValidationResult[]
}

export interface WmrConfigLoadAction {
  type: typeof WMR_CONFIG_LOAD
  accountId: string
  projectId: string
}

interface WmrConfigLoadSuccessAction {
  type: typeof WMR_CONFIG_LOAD_SUCCESS
  accountId: string
  projectId: string
  config: WmrConfigData
}

interface WmrConfigLoadFailAction {
  type: typeof WMR_CONFIG_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface WmrRulesetUploadAction {
  type: typeof WMR_RULESET_UPLOAD
  accountId: string
  projectId: string
  file: File
}

interface WmrRulesetUploadSuccessAction {
  type: typeof WMR_RULESET_UPLOAD_SUCCESS
  accountId: string
  projectId: string
  response: WmrUploadResponse
}

interface WmrRulesetUploadFailAction {
  type: typeof WMR_RULESET_UPLOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface WmrRulesetConfirmAction {
  type: typeof WMR_RULESET_CONFIRM
  accountId: string
  projectId: string
  rulesetId: string
}

interface WmrRulesetConfirmSuccessAction {
  type: typeof WMR_RULESET_CONFIRM_SUCCESS
  accountId: string
  projectId: string
  rulesetId: string
}

interface WmrRulesetConfirmFailAction {
  type: typeof WMR_RULESET_CONFIRM_FAIL
  accountId: string
  projectId: string
  rulesetId: string
  error: any
}

export interface WmrRulesetExportAction {
  type: typeof WMR_RULESET_EXPORT
  accountId: string
  projectId: string
}

interface WmrRulesetExportSuccessAction {
  type: typeof WMR_RULESET_EXPORT_SUCCESS
  accountId: string
  projectId: string
  exportFileSasUrl: string
}

interface WmrRulesetExportFailAction {
  type: typeof WMR_RULESET_EXPORT_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface WmrRulesetUploadResetAction {
  type: typeof WMR_RULESET_UPLOAD_RESET
}

export interface WmrRulesetExportResetAction {
  type: typeof WMR_RULESET_EXPORT_RESET
}
